/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The resized height is shown with up to two decimals. For example, a target width of 1000 at 16:9 gives 562.5.`)
};

const es_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La altura redimensionada se muestra con hasta dos decimales. Por ejemplo, un ancho objetivo de 1000 a 16:9 da 562.5.`)
};

const de_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die geänderte Höhe wird mit bis zu zwei Nachkommastellen angezeigt. Zum Beispiel ergibt eine Zielbreite von 1000 bei 16:9 den Wert 562.5.`)
};

const nl_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gewijzigde hoogte wordt weergegeven met maximaal twee decimalen. Een doelbreedte van 1000 bij 16:9 geeft bijvoorbeeld 562.5.`)
};

const fr_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La hauteur redimensionnée s'affiche avec jusqu'à deux décimales. Par exemple, une largeur cible de 1000 à 16:9 donne 562.5.`)
};

const it_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'altezza ridimensionata è visualizzata con fino a due decimali. Ad esempio, una larghezza target di 1000 a 16:9 dà 562.5.`)
};

const pt_br2_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A altura redimensionada é mostrada com até dois decimais. Por exemplo, uma largura de destino de 1000 em 16:9 resulta em 562.5.`)
};

const pt_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A altura redimensionada é mostrada com até duas casas decimais. Por exemplo, uma largura alvo de 1000 em 16:9 dá 562.5.`)
};

const ja_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リサイズされた高さは最大2つの小数で表示されます。例えば、16:9で1000の目標幅は562.5を与えます。`)
};

const zh_ar_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整后的高度最多以两位小数显示。例如,在16:9比例下,目标宽度为1000时,得到的高度是562.5。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq2_a", locale)
	if (locale === "en") return en_ar_faq2_a(inputs)
	if (locale === "es") return es_ar_faq2_a(inputs)
	if (locale === "de") return de_ar_faq2_a(inputs)
	if (locale === "nl") return nl_ar_faq2_a(inputs)
	if (locale === "fr") return fr_ar_faq2_a(inputs)
	if (locale === "it") return it_ar_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq2_a(inputs)
	if (locale === "pt") return pt_ar_faq2_a(inputs)
	if (locale === "ja") return ja_ar_faq2_a(inputs)
	return zh_ar_faq2_a(inputs)
};